import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { storeContext } from "../../../../store/root-store";
import { DateHelper } from "../../../../helpers/DateHelper";
import { FilterDates, IFilterDate } from "../../../../store/FilterDates";
import { DateSerivce } from "../../../../services/DateService";

// let remainingDays = DateSerivce.getDaysForPanel();

export const DatesPanel = observer(() => {
  const { eventsStore, messagesStoreGl, settingsGl, tagsGl, filterDatesGl } =
    useContext(storeContext);
  const onPickDate = (filterDate: IFilterDate) => {
    settingsGl.clearAllFilters();
    filterDatesGl.onPickDate(filterDate);
  };
  const onPickAll = () => {
    settingsGl.clearAllFilters();

    filterDatesGl.onPickAllDays();
  };
  return (
    <div
      className="base-page-element d-flex"
      style={{
        paddingTop: 0.5 + "rem",
        width: 100 + "%",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "auto",
          overflowY: "scroll",
          fontSize: 1 + "rem",
        }}
      >
        <div
          onClick={onPickAll}
          className={
            "full-list-of-tags-item  " +
            (filterDatesGl._listOfSelecedDates.length == 0
              ? "full-list-of-tags-item-selected"
              : "")
          }
          style={{ marginLeft: 0 + "px" }}
        >
          <div className="full-list-of-tags-item-text">Все даты</div>
        </div>
        {filterDatesGl.remainingDays.map((el, index) => {
          return (
            <div
              key={el.dateSec}
              onClick={() => onPickDate(el)}
              className={
                "full-list-of-tags-item  " +
                (filterDatesGl._listOfSelecedDates.filter((t) =>
                  FilterDates.isTheSameDay(t.dateSec, el.dateSec)
                ).length
                  ? "full-list-of-tags-item-selected"
                  : "")
              }
            >
              {index === 0 && (
                <div className="full-list-of-tags-item-text">Сегодня</div>
              )}
              {index === 1 && (
                <div className="full-list-of-tags-item-text">Завтра</div>
              )}
              {index > 1 && (
                <div className="full-list-of-tags-item-text">
                  {
                    //el.name +
                    //   "(" +
                    el.date.split("-").reverse().splice(0, 2).join(".")
                    // + ")"
                  }
                </div>
              )}
            </div>
          );
        })}
      </div>
      {/* <div className="pick-all-dates-button" style={{ fontSize: 0.8 + "rem" }}>
        <div className="full-list-of-tags-item">
          <div className="full-list-of-tags-item-text">Вcе</div>
        </div>
      </div> */}
    </div>
  );
});
